import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {HttpHeaderService} from "../../utils/http/http-header.service";
import {Observable} from "rxjs";
import {AntragTicketSchoolInfoDto} from "../../../models/antrag-ticket/AntragTicketSchoolInfoDto";
import {AntragTicketSchoolInfoUpdateDto} from "../../../models/antrag-ticket/AntragTicketSchoolInfoUpdateDto";


@Injectable({
  providedIn: 'root'
})
export class AntragTicketSchoolInfoService {

  configUrl = 'api/antrag-ticket/school-info';

  constructor(
    private http: HttpClient,
    private headerService: HttpHeaderService
  ) {}

  getSchoolInfoByAntrag(antragId: string): Observable<AntragTicketSchoolInfoDto> {
    return this.http.get<AntragTicketSchoolInfoDto>(
      this.configUrl+'/'+antragId,
      { headers: this.headerService.getAuthHeaderApplicationJson() }
    );
  }

  updateSchoolInfoByAntrag(antragId: string, schoolInfoUpdateDto: AntragTicketSchoolInfoUpdateDto): Observable<AntragTicketSchoolInfoDto> {
    return this.http.post<AntragTicketSchoolInfoDto>(
      this.configUrl+'/'+antragId,
      schoolInfoUpdateDto,
      { headers: this.headerService.getAuthHeaderApplicationJson() }
    );
  }
}
